import { BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('/nnc/nnc-enrichment');
  }
}

export default new API();
